
import React, { useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useUpdatePass } from "@/features/user/hooks/use-update-pass";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { PasswordForm } from "@/shared/components/text-box/password-form";
import { StrengthBar } from "@/shared/components/strength-bar/strength-bar";

interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

export const UpdatePassModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    oldPassword,
    newPassword,
    confirmNewPassword,
    passwordError, // パスワードのエラーメッセージ
    isActiveUpdateButton,
    onChangeOldPassword,
    onChangeNewPassword,
    onChangeConfirmNewPassword,
    onClickUpdate,
    changeUpdateButtonState,
  } = useUpdatePass({ onTapCompleteModal });


  useEffect(() => {
    changeUpdateButtonState();
  }, [oldPassword, newPassword, confirmNewPassword]);

  // 変更ボタンに付与するID
  const updatePassButton = "update_pass_button";

  return (
    <BasePageModal
      className="md-user-profile update-pass-modal"
      title="パスワード変更"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="変更"
          onClick={() => onClickUpdate(oldPassword, newPassword, confirmNewPassword)}
          id={updatePassButton}
          loadingNegative={true}
          isActive={isActiveUpdateButton}
        />
      }
      disableOverlayClose={true}
    >
      <h2>現在のパスワードと新しいパスワードを入力してください</h2>
      <ul className="form">
        <li>
          <PasswordForm
            title="現在のパスワード"
            onChange={(value) => onChangeOldPassword(value)}
          />
          <PasswordForm
            title="新しいパスワード"
            onChange={(value) => onChangeNewPassword(value)}
          />
          {newPassword && <StrengthBar password={newPassword} />}
          <PasswordForm
            title="新しいパスワード（確認用）"
            onChange={(value) => onChangeConfirmNewPassword(value)}
          />
          {passwordError && <span className="pass_error">{passwordError}</span>}
        </li>
      </ul>
      <div className="notice">
        <p>※パスワードは半角英数8文字以上で入力してください。</p>
        <p>※記号は利用できません。</p>
      </div>
    </BasePageModal>
  );
};
